import { useMemo } from 'react';
import { multiUiPropSelector, RequestStatus } from 'shared/config';
import { checkRequestStatusEquality } from 'shared/lib';

import { useShallowSelector } from '../useShallowSelector';

type PropKeys = string | string[];

export const useLoadingState = (propKeys: PropKeys): boolean[] => {
  const keys = useMemo(() => (Array.isArray(propKeys) ? propKeys : [propKeys]), [propKeys]);
  const statuses = useShallowSelector(multiUiPropSelector(keys));

  return useMemo(() => keys.map((key) => checkRequestStatusEquality(statuses[key], RequestStatus.REQUEST)), [statuses]);
};
